const SUPPORT_ASSISTANT_MESSAGE_DRAFT_STORAGE_KEY_PREFIX = 'supportAssistantMessageDraft'

export const CLEAR_SUPPORT_ASSISTANT_MESSAGE_DRAFT_EVENT = 'supportAssistant:clear-message-draft'

export function getSupportAssistantMessageDraftStorageKey(chatId: string) {
  return `${SUPPORT_ASSISTANT_MESSAGE_DRAFT_STORAGE_KEY_PREFIX}:${chatId}`
}
